import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.CutOutRoot),
  () => import('./CutOut'),
  (CutOut) => {
    ComponentUtil.binder(Hooks.CutOutRoot, CutOut);
  },
);
